import calculateTranslate from './calculateTranslate'
import type { ITweenFromToParams, ITweenTransformParams } from './definitions'
import getScaleDifference from './getScaleDifference'

const START = 0
const BASE_SCALE = 1

/**
 * Animálás egyik elem pozíciójából egy másik elem pozíciójába.
 * @param params - Paraméterek.
 */
export default function fromTo (params: ITweenFromToParams): ITweenTransformParams {
  const { from, needScale, scaleDiff, to, toCenter, ...rest } = params

  const translate = calculateTranslate(from, to, toCenter)

  // HA kell scale
  const scale = needScale
    // HA adtunk meg értéket -> akkora lesz a scale
    // HA nem adtunk meg értéket, akkor a to-hoz képest nézzük a scalet.
    ? scaleDiff ?? getScaleDifference(from, to)
    // HA nem kell scale
    : BASE_SCALE

  const transformParams: ITweenTransformParams = {
    elem: from,
    definitions: {
      translateX: [ START, translate.x ],
      translateY: [ START, translate.y ],
      scale: [ BASE_SCALE, scale ]
    },
    ...rest
  }

  if (params.onEnd) {
    transformParams.onEnd = params.onEnd
  }

  return transformParams
}
